import { Injector } from '@angular/core';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { BetfinderComponentLoaderService } from './betfinder-component-loader.service';

export const BetfinderPreloader = {
    id: 'betfinder-preload',
    loaderFn: (injector: Injector) =>
        Promise.all([injector.get(BetfinderComponentLoaderService).preloadBetfinderModule(), import('@frontend/sports/popup/feature')]),
    product: ClientConfigProductName.SPORTS,
};
